import { Injectable, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { chatActions } from './chat.actions';
import { ChatState } from './chat.interfaces';
import { chatQuery, getCommChannelContent } from './chat.selectors';
import { OmniAnalyticsService } from '@cigna/omni/shared';
import { FeatureTogglesFacade } from '@cigna/features';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class OmniChatFacade implements OnDestroy {
  public backButtonContent$ = this.store$.pipe(
    select(chatQuery.getBackButtonContent),
  );
  public canGoBack$ = this.store$.pipe(select(chatQuery.getCanGoBack));
  public commChannelContent$ = this.store$.pipe(select(getCommChannelContent));
  public currentComponent$ = this.store$.pipe(
    select(chatQuery.getCurrentComponent),
  );
  public direction$ = this.store$.pipe(select(chatQuery.getDirection));
  public isBackButtonDisabled$ = this.store$.pipe(
    select(chatQuery.isBackButtonDisabled),
  );
  public isShellOpen$ = this.store$.pipe(select(chatQuery.isChatOpen));
  public isShellMinimized$ = this.store$.pipe(
    select(chatQuery.isChatMinimized),
  );
  public headerTitle$ = this.store$.pipe(select(chatQuery.getHeaderTitle));
  public headerBackgroundClass$ = this.store$.pipe(
    select(chatQuery.getHeaderBackgroundClass),
  );
  public shouldClose$ = this.store$.pipe(select(chatQuery.shouldClose));
  public toggleChatStateButton$ = this.store$.pipe(
    select(chatQuery.toggleChatStateButton),
  );
  public isUnmuted$ = this.store$.pipe(select(chatQuery.getMuteState));

  public isHistory$ = this.store$.pipe(select(chatQuery.isHistory));

  isEvernorth: boolean;
  isSubscribeEvm: Subscription;

  constructor(
    private analytics: OmniAnalyticsService,
    private store$: Store<ChatState>,
    private featureToggleFacade: FeatureTogglesFacade,
  ) {
    this.isSubscribeEvm = this.featureToggleFacade
      .featuresEnabled(['isEvernorthEnabled'])
      .subscribe((isEvm) => {
        this.isEvernorth = isEvm;
      });
  }

  public back(): void {
    this.store$.dispatch(new chatActions.BeforeBack());
    this.store$.dispatch(new chatActions.Back());
  }

  public goHome(): void {
    this.store$.dispatch(new chatActions.GoHome());
  }

  public homeView(): void {
    this.store$.dispatch(new chatActions.HomeView());
  }

  public openDialog(): void {
    this.store$.dispatch(new chatActions.OpenDialog());
  }

  public dialogView(): void {
    this.store$.dispatch(new chatActions.DialogView());
  }

  public historyView(): void {
    this.analytics.track('chatHistoryView', {});
  }

  public openHistory(): void {
    if (this.isEvernorth) {
      const linkText = 'View All';
      this.analytics.trackEvent('chatConversationHistoryViewAll', { linkText });
    } else {
      this.analytics.track('viewAllConversations', {});
    }
    this.store$.dispatch(new chatActions.OpenHistory());
  }

  public toggleChatState(): void {
    this.store$.dispatch(new chatActions.ToggleChatState());
  }

  public toggleMuteState(): void {
    this.store$.dispatch(new chatActions.ToggleMuteState());
  }

  public closeDialog(): void {
    this.store$.dispatch(new chatActions.BeforeBack());
    this.store$.dispatch(new chatActions.HeaderClose());
  }

  ngOnDestroy(): void {
    this.isSubscribeEvm.unsubscribe();
  }
}
